import { type CanvasTokenNode } from './store/slices/createCanvasTokenNodeSlice';

/**
 * Filters out malformed mediaMap entries from S3 (e.g. `output/` prefixed keys
 * that only have `image` and `original` fields but lack `group` and `type`).
 *
 */
export function sanitizeMediaMap(mediaMap: object): Record<string, CanvasTokenNode> {
  return Object.fromEntries(
    Object.entries(mediaMap).filter(
      (entry): entry is [string, CanvasTokenNode] =>
        entry[1] != null && typeof entry[1] === 'object' && 'group' in entry[1] && 'type' in entry[1],
    ),
  );
}
